/* eslint-disable max-classes-per-file */

import { RequestListProductTypeEnums } from "@/types/product/account/history";

import { ResponsePresenter } from "../../common/commonClassPresenter";
import {
  DayPlanDataPresenter,
  ListStepDataPresenter,
  RePaymentPresenter,
} from "./historyBookingCommonInterface";

class CarRentalRoutePresenter {
  locationName: string;

  dateTimeOri: string;

  date: string;

  time: string;

  constructor(response: any) {
    this.locationName = response?.locationName || "";
    this.dateTimeOri = response?.dateTimeOri || "";
    this.date = response?.date || "";
    this.time = response?.time || "";
  }
}

class CarRentalDriverPresenter {
  title: string;

  firstname: string;

  lastname: string;

  email: string;

  phone: string;

  country: string;

  flightNo: string;

  serviceType: string;

  constructor(response: any) {
    this.title = response?.title || "";
    this.firstname = response?.firstname || "";
    this.lastname = response?.lastname || "";
    this.email = response?.email || "";
    this.phone = response?.phone || "";
    this.country = response?.country || "";
    this.flightNo = response?.flightNo || "";
    this.serviceType = response?.serviceType || "";
  }
}

export class CarRentalListDataPresenter {
  type: string;

  rsvnId: string;

  reservationNo: string;

  bookingInternalNo: string;

  pinCode: string;

  bookingDateOri: string;

  bookingDate: string;

  dateAmount: number;

  bookingStatus: string;

  paymentStatus: string;

  city: string;

  vehicleName: string;

  image: string;

  dayPlan: DayPlanDataPresenter;

  payment: RePaymentPresenter;

  isGreenCertificate: boolean;

  driver: CarRentalDriverPresenter;

  routePickup: CarRentalRoutePresenter;

  routeDropoff: CarRentalRoutePresenter;

  price: number;

  currency: string;

  dateCancelOri: string;

  productType: string;

  dateCancel: string;

  isPayLater: boolean;

  paylaterDeadlineDate: string;

  paylaterDeadlineDateLang: string;

  paylaterChargedDate: string;

  isConjobsFail: boolean;

  // greenCertification: any
  constructor(response: any) {
    this.type = response?.type || "";
    this.rsvnId = response?.rsvnId || "";
    this.reservationNo = response?.reservationNo || "";
    this.bookingInternalNo = response?.bookingInternalNo || "";
    this.pinCode = response?.pinCode || "";
    this.bookingDateOri = response?.bookingDateOri || "";
    this.bookingDate = response?.bookingDate || "";
    this.dateAmount = response?.dateAmount || 0;
    this.bookingStatus = (response?.bookingStatus || "").toLocaleLowerCase();
    this.paymentStatus = (response?.paymentStatus || "").toLocaleLowerCase();
    this.city = response?.city || "";
    this.vehicleName = response?.vehicleName || "";
    this.image = response?.image || "";
    this.dayPlan = new DayPlanDataPresenter(response?.dayPlan);
    this.payment = new RePaymentPresenter(response?.payment);
    this.isGreenCertificate = response?.isGreenCertificate || false;
    this.driver = new CarRentalDriverPresenter(response?.driver);
    this.routePickup = new CarRentalRoutePresenter(response?.routePickup);
    this.routeDropoff = new CarRentalRoutePresenter(response?.routeDropoff);
    this.price = response?.price || 0;
    this.currency = response?.currency || "";
    this.dateCancelOri = response?.dateCancelOri || "";
    this.productType = RequestListProductTypeEnums.CAR;
    this.dateCancel = response?.dateCancel || "";
    this.isPayLater = response?.isPayLater || false;
    this.paylaterDeadlineDate = response?.paylaterDeadlineDate || "";
    this.paylaterDeadlineDateLang = response?.paylaterDeadlineDateLang || "";
    this.paylaterChargedDate = response?.paylaterChargedDate || "";
    this.isConjobsFail = response?.isConjobsFail || false;
  }
}

export class CarRentalListStepData extends ListStepDataPresenter<
  CarRentalListDataPresenter[]
> {
  constructor(response: any) {
    super(response, (data) =>
      (data || []).map((val: any) => new CarRentalListDataPresenter(val)),
    );
  }
}

export class ResponseGetHistoryCarRentalListPresenter extends ResponsePresenter<
  CarRentalListStepData[]
> {
  constructor(response: any) {
    super(response, (data) =>
      (data || []).map((val: any) => new CarRentalListStepData(val)),
    );
  }
}
